import styles from './message.module.css';

export interface IMessage {
  type: 'error' | 'success';
  text: string;
}
interface MessageProps {
  message?: IMessage | null;
}

const Message: React.FC<MessageProps> = ({ message = null }: MessageProps) => {
  if (!message) {
    return null;
  }
  return (
    <div className={`${styles.message} ${styles[`message--${message.type}`]}`}>
      {message.text}
    </div>
  );
};

export default Message;
